import Vue from 'vue'
import VeeValidate from 'vee-validate'
import VeeValidateJaLocale from 'vee-validate/dist/locale/ja'

VeeValidate.Validator.localize('ja', VeeValidateJaLocale)
Vue.use(VeeValidate, { locale: 'ja' })



// WEBPACK FOOTER //
// ./src/validate/validate.js